import { mapKeys } from "es-toolkit/object"
import { getBreakpointPixelValue } from "../Media"
import type { Breakpoints, CarouselOptions, EmblaOptionsType } from "./types"

export function getCarouselOptions(options: CarouselOptions): EmblaOptionsType {
  if (options.breakpoints) {
    const { breakpoints, ...rest } = options
    const breakpointsWithPixelValues = mapKeys(
      breakpoints,
      (_value, key) => `(min-width: ${getBreakpointPixelValue(key)}px)`,
    ) as Breakpoints
    return {
      ...rest,
      breakpoints: breakpointsWithPixelValues,
    }
  }

  return options
}
